import { RevenueTable } from "./RevenueTable";

export function ReportSummaryTransactionSection({
  transactionData,
  isLoading,
}) {
  return (
    <div>
      <span className="mb-4 text-xl text-[#1A1A1A]">Transaction Details</span>
      <RevenueTable transactionData={transactionData} isLoading={isLoading} />
    </div>
  );
}
